import React from 'react';
import Tippy from "@tippyjs/react";


const ButtonTippyCopy = ({ buttonText, content, className, classNameTippy, iconClassName, iconStyle }) => {
    return (
        <div className={`d-inline-block ${className}`}>
            <Tippy
                animation="fade"
                theme="custom"
                content="Copied"
                placement="bottom"
                trigger="click"
                className={`custom-tippy ${classNameTippy ? classNameTippy : ""}`}
                onShow={instance => {
                    setTimeout(() => {
                        instance.hide();
                    }, 1000);
                }}>
                <button className="save-btn" onClick={() => navigator.clipboard.writeText(`${content}`)}>
                    {buttonText}
                    <i className={`fas fa-copy ml-2 ${iconClassName}`} style={iconStyle ? iconStyle : {}}></i>
                </button>
            </Tippy>
        </div>
    )
}

export default ButtonTippyCopy
